import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./DropdownNav.css";

export default function DropdownNav({ menuOpen, setMenuOpen }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleDropdown = (name) => {
    setOpenDropdown(openDropdown === name ? null : name);
  };

  return (
    <>
      {/* Overlay (visible only when drawer is open) */}
      <div
        className={`ijacna-overlay ${menuOpen ? "show" : ""}`}
        onClick={() => setMenuOpen(false)}
      ></div>

      <nav className={`ijacna-navbar ${menuOpen ? "open" : ""}`}>

        <div className="drawer-header">
          <img
            src="/images/ijacna-logo.png"
            alt="IJACNA Logo"
            className="drawer-logo"
          />
          <h3>IJACNA</h3>
          <button className="drawer-close-btn" onClick={() => setMenuOpen(false)}>
            ✕
          </button>
        </div>

        <ul>
          {/* Home */}
          <li className={location.pathname === "/" ? "active" : ""}>
            <a href="/">Home</a>
          </li>

          {/* Aim & Scope */}
          <li className={location.pathname === "/AimAndScope" ? "active" : ""}>
            <a href="/AimAndScope">Aim & Scope</a>
          </li>

          {/* Authors Guidelines */}
          <li
            className={`ijacna-dropdown ${
              openDropdown === "authors" ? "open" : ""
            } ${
              ["/AuthorsGuideline", "/Topics", "/Fees"].includes(
                location.pathname
              )
                ? "active"
                : ""
            }`}
            onClick={() => toggleDropdown("authors")}
          >
            <span className="dropdown-toggle-btn">
              Authors Guidelines <i className="fas fa-caret-down"></i>
            </span>

            <ul className="ijacna-dropdown-menu">
              <li
                className={
                  location.pathname === "/AuthorsGuideline" ? "active" : ""
                }
              >
                <a href="/AuthorsGuideline">Authors Guideline</a>
              </li>

              <li className={location.pathname === "/Topics" ? "active" : ""}>
                <a href="/Topics">Topics</a>
              </li>

              <li className={location.pathname === "/Fees" ? "active" : ""}>
                <a href="/Fees">Fees</a>
              </li>
            </ul>
          </li>

          {/* Downloads */}
          <li
            className={`ijacna-dropdown ${
              openDropdown === "downloads" ? "open" : ""
            } ${
              ["/Copyrights", "/ManuscriptTemplate"].includes(
                location.pathname
              )
                ? "active"
                : ""
            }`}
            onClick={() => toggleDropdown("downloads")}
          >
            <span className="dropdown-toggle-btn">
              Downloads <i className="fas fa-caret-down"></i>
            </span>

            <ul className="ijacna-dropdown-menu">
              <li
                className={
                  location.pathname === "/Copyrights" ? "active" : ""
                }
              >
                <a href="/Copyrights">Copyrights</a>
              </li>

              <li
                className={
                  location.pathname === "/ManuscriptTemplate" ? "active" : ""
                }
              >
                <a href="/ManuscriptTemplate">Manuscript Template</a>
              </li>
            </ul>
          </li>

          {/* Online Submission */}
          <li
            className={
              location.pathname === "/OnlineSubmission" ? "active" : ""
            }
          >
            <a href="/OnlineSubmission">Online Submission</a>
          </li>

          {/* Historical Repository */}
          <li className={location.pathname === "/Volumes" ? "active" : ""}>
            <a href="/Volumes">Historical Repository</a>
          </li>

          {/* Editorial Panel */}
          <li
            className={`ijacna-dropdown ${
              openDropdown === "editorial" ? "open" : ""
            } ${
              ["/Reviewers", "/JoinAsReviewer"].includes(location.pathname)
                ? "active"
                : ""
            }`}
            onClick={() => toggleDropdown("editorial")}
          >
            <span className="dropdown-toggle-btn">
              Editorial Panel <i className="fas fa-caret-down"></i>
            </span>

            <ul className="ijacna-dropdown-menu">
              <li className={location.pathname === "/Reviewers" ? "active" : ""}>
                <a href="/Reviewers">Reviewer</a>
              </li>

              <li
                className={
                  location.pathname === "/JoinAsReviewer" ? "active" : ""
                }
              >
                <a href="/JoinAsReviewer">Join As Reviewer</a>
              </li>
            </ul>
          </li>

          {/* Contact Us */}
          <li className={location.pathname === "/ContactUs" ? "active" : ""}>
            <a href="/ContactUs">Contact Us</a>
          </li>
        </ul>
      </nav>
    </>
  );
}
